import { createSelector } from 'reselect'

/**
 * Direct selector to the app state domain
 */
export const selectGlobal = () => (state) => state.global

export const selectLanguageLoaded = () =>
  createSelector(selectGlobal(), (substate) => substate.languageLoaded)

export const selectCurrentUser = () =>
  createSelector(selectGlobal(), (substate) => substate.user)

export const selectUserSubscription = () =>
  createSelector(selectGlobal(), (substate) => substate.user?.subscription)

export const selectUserPreferences = () =>
  createSelector(selectGlobal(), (substate) => substate.user.preferences)

export const selectLoadingUser = () =>
  createSelector(selectGlobal(), (substate) => substate.isLoadingUser)

export const selectUpdatingUser = () =>
  createSelector(selectGlobal(), (substate) => substate.isUpdatingUser)

export const selectLifetimeReminderModal = () =>
  createSelector(selectGlobal(), (substate) => substate.lifetimeReminderModal)

export const selectNavigationChangeModall = () =>
  createSelector(selectGlobal(), (substate) => substate.navigationChangeModal)

export const selectAIWPlanModal = () =>
  createSelector(selectGlobal(), (substate) => substate.aiwPlanModal)

export const selectATPCrossSellModal = () =>
  createSelector(selectGlobal(), (substate) => substate.atpCrossSellModal)

export const selectAvailableAddons = () =>
  createSelector(selectGlobal(), (substate) => substate.user?.addons)

export const selectMultiUsers = () =>
  createSelector(selectGlobal(), (substate) => substate.multiUsers)

export const selectInvitedUsers = () =>
  createSelector(selectGlobal(), (substate) => substate.invitedUsers)

export const selectLoginLimitModal = () =>
  createSelector(selectGlobal(), (substate) => substate.loginLimitModal)

export const selectHideUpdateBillingInfoAlert = () =>
  createSelector(
    selectGlobal(),
    (substate) => substate.hideUpdateBillingInfoAlert,
  )

export const selectExtraHeaderHeight = () =>
  createSelector(selectGlobal(), (substate) => substate.extraHeaderHeight)

export const selectIsCheckingAdblock = () =>
  createSelector(selectGlobal(), (substate) => substate.isCheckingAdblock)

export const selectIsDetectedAdblock = () =>
  createSelector(selectGlobal(), (substate) => substate.isDetectedAdblock)

export const selectIsClosedAdblockDetectModal = () =>
  createSelector(
    selectGlobal(),
    (substate) => substate.isClosedAdblockDetectModal,
  )

export const selectPromptModal = () =>
  createSelector(selectGlobal(), (substate) => substate.promptModal)

export const selectIsLoadingAddons = () =>
  createSelector(selectGlobal(), (substate) => substate.isLoadingAddons)

export const selectNewLimitsChangingPlans = () =>
  createSelector(selectGlobal(), ({ user }) => {
    if (!user) {
      return {
        locations: 20,
        keywords: 25,
        competitors: 2,
      }
    }

    if (
      !user.subscription ||
      user.tier === 'restart' ||
      user.tier === 'tier0'
    ) {
      return {
        locations: 20,
        keywords: 125,
        competitors: 5,
      }
    }

    if (user.tier === 'tier1') {
      return {
        locations: 20,
        keywords: 150,
        competitors: 10,
      }
    }

    return {
      locations: 20,
      keywords: 300,
      competitors: 15,
    }
  })
